import { useTranslation } from '@/i18n/useTranslation';

import type { ReactNode } from 'react';

export function EmptyState({
  title,
  description,
  action,
  icon,
}: {
  title?: string;
  description?: string;
  action?: ReactNode;
  icon?: ReactNode;
}) {
  const { t } = useTranslation();
  return (
    <div className="empty-state" role="status">
      {icon}
      <h3>{title ?? t('Nothing here yet')}</h3>
      {description && <p>{description}</p>}
      {action}
    </div>
  );
}
